import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'normalize.css/normalize.css';
import './index.css';
import Login from  './Login';

// console.log(JSON.stringify(process.env.REACT_APP_MY_ENV_VAR || 'DEFAULT'));
ReactDOM.render(<Login/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
